import React from "react";
import { connect } from "react-redux";
import PageSummary from "../../../../../CommonComponents/PageSummary/PageSummary";
import PageAccountSummary from "../../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary";
import { GrantAgreementHeading, PreloaderController } from "../styles";
import Preloader from "../../../../../CommonComponents/Preloader/Preloader";
import { ContentMessage, Types } from "../../../../../CommonComponents/ContentMessages";
import { agreementSummaryDerivedStates } from '../Selectors/AgreementSummarySelectors';
class GrantAgreementSummary extends React.Component {
  renderFundSummary(accObj) {
    return (
      <PageAccountSummary
        dataName={accObj.key}
        label={accObj.label}
        value={accObj.value}
        themeColor={'#505050'}
      />
    );
  }
  fundSummaryConfiguration = () => {
    return this.props.accountData.accountId &&
      this.props.accountData.accountName
      ? [
          this.renderFundSummary({
            key: 'accountName',
            label: this.props.accountData.accountName,
            value: this.props.accountData.accountId
          }),
          this.renderFundSummary({
            key: 'availaleBalance',
            label: 'Available Balance',
            value: this.props.accountData.availableBalance ? this.props.accountData.availableBalance : "$0.00"
          })
        ]
      : [
          <PreloaderController>
            <Preloader />
          </PreloaderController>
        ];
  };
  render() {
    return (
      <>
        <GrantAgreementHeading>
          <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page={'Grant Agreement Landing'} property="field_page_title" defaultMessage={'Grant Agreement Landing'} />
        </GrantAgreementHeading>
        <PageSummary fundSummaryConfig={this.fundSummaryConfiguration()} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...agreementSummaryDerivedStates(state.toJS()),
});
export default connect(
  mapStateToProps,
  null
)(GrantAgreementSummary);
